import { Injectable } from "@angular/core";
import { Judge, JudgeCategory, JudgeScore } from "../model/judge";
import { ApiService } from "./api";
import { Livestock } from "model/livestock";
import { StockGroup } from "model/stock-group";
import { StockContractor } from "model/stock-contractor";

@Injectable()
export class StockService {
    constructor(
        private api: ApiService
    ) { }

    async addStockGroup(stockGroup: StockGroup, rodeoId: number) {
        return await this.api.postWithAuth<StockGroup>(`${this.api.endpoints.stock}/CreateStockGroup?rodeoId=${rodeoId}`, stockGroup);
    }

    async updateStockGroup(stockGroup: StockGroup) {
        return await this.api.postWithAuth<StockGroup>(`${this.api.endpoints.stock}/UpdateStockGroup`, stockGroup);
    }

    async addLivestock(stockGroupId: number, livestock: Livestock[]) {
        return await this.api.postWithAuth<Livestock[]>(`${this.api.endpoints.stock}/AddLivestockToGroup?stockGroupId=${stockGroupId}`, livestock);
    }

    async deleteLivestock(stockGroupId: number, livestock: Livestock[]) {
        return await this.api.postWithAuth<StockGroup>(`${this.api.endpoints.stock}/DeleteLivestockFromGroup?stockGroupId=${stockGroupId}`, livestock);
    }

    async addStockContractor(name: string) {
        return await this.api.postWithAuth<StockContractor>(`${this.api.endpoints.stock}/CreateStockContractor`, { name: name });
    }

    async searchStockContractors(name: string) {
        return await this.api.getWithAuth<StockContractor[]>(`${this.api.endpoints.search}/StockContractors?name=${name}`);
    }


    /*
    deleteCategory(id: number) {
        return this.api.deleteWithAuth(`${this.api.endpoints.judges}/DeleteCategory?id=${id}`);
    }
    */
}


// WEBPACK FOOTER //
// ./src/services/stock.service.ts